import { useState, useCallback } from 'react';
import { Snackbar, Alert, Slide } from '@mui/material';

// Slide transition for toast
function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

export const useToast = () => {
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'info', // 'success', 'error', 'warning', 'info'
    duration: 4000
  });

  const showToast = useCallback((message, severity = 'info', duration = 4000) => {
    setToast({
      open: true,
      message,
      severity,
      duration
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, open: false }));
  }, []);

  const ToastComponent = () => (
    <Snackbar
      open={toast.open}
      autoHideDuration={toast.duration}
      onClose={hideToast}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        '& .MuiSnackbarContent-root': {
          minWidth: '300px',
          maxWidth: '500px'
        }
      }}
    >
      <Alert
        onClose={hideToast}
        severity={toast.severity}
        variant="filled"
        sx={{ 
          width: '100%',
          '& .MuiAlert-message': {
            fontSize: '14px',
            fontWeight: 500
          }
        }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );

  return {
    showToast,
    hideToast,
    ToastComponent
  };
};
